module.exports = __webpack_public_path__ + "img/icon-child-folder.13a91c9c.svg";